import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Globus = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.55454 2.31531C8.31407 2.061 8.12674 2 8.00094 2C7.87514 2 7.6878 2.061 7.44733 2.31531C7.20547 2.57102 6.957 2.97682 6.73433 3.53355C6.34673 4.50248 6.0769 5.82899 6.01465 7.33335H9.9872C9.925 5.82899 9.65514 4.50248 9.2676 3.53355C9.04487 2.97682 8.7964 2.57102 8.55454 2.31531Z"
        fill="currentColor"
      />
      <path
        d="M9.9872 8.66675H6.01465C6.0769 10.1711 6.34673 11.4976 6.73433 12.4665C6.957 13.0233 7.20547 13.4291 7.44733 13.6847C7.6878 13.9391 7.87514 14.0001 8.00094 14.0001C8.12674 14.0001 8.31407 13.9391 8.55454 13.6847C8.7964 13.4291 9.04487 13.0233 9.2676 12.4665C9.65514 11.4976 9.925 10.1711 9.9872 8.66675Z"
        fill="currentColor"
      />
      <path
        d="M4.68027 7.33342C4.74307 5.68862 5.03655 4.18791 5.49633 3.03843C5.72851 2.458 6.01355 1.94078 6.35423 1.53833C3.67725 2.21846 1.64668 4.51837 1.36719 7.33342H4.68027Z"
        fill="currentColor"
      />
      <path
        d="M1.36719 8.66675H4.68027C4.74307 10.3115 5.03655 11.8122 5.49633 12.9617C5.72851 13.5421 6.01355 14.0593 6.35422 14.4618C3.67724 13.7817 1.64668 11.4817 1.36719 8.66675Z"
        fill="currentColor"
      />
      <path
        d="M11.3216 8.66675H14.6346C14.3552 11.4817 12.3246 13.7817 9.64764 14.4618C9.98831 14.0593 10.2734 13.5421 10.5055 12.9617C10.9653 11.8122 11.2588 10.3115 11.3216 8.66675Z"
        fill="currentColor"
      />
      <path
        d="M14.6346 7.33342C14.3552 4.51837 12.3246 2.21846 9.64764 1.53833C9.98831 1.94078 10.2734 2.458 10.5055 3.03843C10.9653 4.18791 11.2588 5.68862 11.3216 7.33342H14.6346Z"
        fill="currentColor"
      />
    </svg>
  ),
)
Globus.displayName = 'Globus'

export default Globus
